
import { oz } from '@weft/utils';
import { NewCommitmentLineItemSchema, NewUsageLineItemSchema } from './line-item-schemas';
import { NewFixedLineItemSchema } from './line-item-schemas/fixed-line-item/new-fixed-line-item-schema';
import { NewPromotionLineItemSchema } from './line-item-schemas/promotion-line-item/new-promotion-line-item-schema';

export const NewLineItemSchema = oz.discriminatedUnion('type', [
  NewFixedLineItemSchema,
  NewUsageLineItemSchema,
  NewCommitmentLineItemSchema,
  NewPromotionLineItemSchema,
]).openapi('NewLineItem');

export type NewLineItem = oz.infer<typeof NewLineItemSchema>;